module.exports = __webpack_public_path__ + "image/solution_icon4.png";